var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNavHistory = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clock",
    clipPath: "url(#clip0_0_64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.27273 2.125C12.8864 2.125 15.8182 4.98047 15.8182 8.5C15.8182 12.0195 12.8864 14.875 9.27273 14.875C7.05 14.875 5.08295 13.7959 3.9 12.1424C3.55568 11.6609 2.87386 11.5447 2.37955 11.8801C1.88523 12.2154 1.76591 12.8795 2.11023 13.3609C3.68523 15.559 6.30682 17 9.27273 17C14.0932 17 18 13.1949 18 8.5C18 3.80508 14.0932 0 9.27273 0C6.35114 0 3.76705 1.39785 2.18182 3.54277V2.65625C2.18182 2.06855 1.69432 1.59375 1.09091 1.59375C0.4875 1.59375 0 2.06855 0 2.65625V6.375C0 6.9627 0.4875 7.4375 1.09091 7.4375H1.92955C1.94659 7.4375 1.96364 7.4375 1.98068 7.4375H4.9125C5.51591 7.4375 6.00341 6.9627 6.00341 6.375C6.00341 5.7873 5.51591 5.3125 4.9125 5.3125H3.60682C4.73523 3.40664 6.85227 2.125 9.27273 2.125ZM10.0909 5.04688C10.0909 4.60527 9.72614 4.25 9.27273 4.25C8.81932 4.25 8.45455 4.60527 8.45455 5.04688V8.5C8.45455 8.7125 8.53977 8.91504 8.69318 9.06445L11.1477 11.4551C11.4682 11.7672 11.9864 11.7672 12.3034 11.4551C12.6205 11.143 12.6239 10.6383 12.3034 10.3295L10.0875 8.17129V5.04688H10.0909Z",
    fill: "#850064"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_64"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNavHistory);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/nav-history.6f5320cae9417207d044ae8f1cbe8ff7.svg";